import { COLLECTIONS } from '../../constants/collections';
import { createDocument, getDocument, getAllDocuments, updateDocument, deleteDocument } from './firestoreService';

/**
 * Factory Service - Fabrika yönetimi
 */

const getCollectionPath = (tenantId) => `tenants/${tenantId}/${COLLECTIONS.FACTORIES}`;

// Create factory
export const createFactory = async (factoryData, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');

    const data = {
        ...factoryData,
        tenantId,
        isActive: true,
        createdAt: new Date(),
        updatedAt: new Date()
    };
    return await createDocument(getCollectionPath(tenantId), data);
};

// Get factory by ID
export const getFactory = async (factoryId, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    return await getDocument(getCollectionPath(tenantId), factoryId);
};

// Get all factories for a tenant
export const getAllFactories = async (tenantId, activeOnly = false) => {
    if (!tenantId) throw new Error('Tenant ID is required');

    const conditions = [];

    if (activeOnly) {
        conditions.push({ type: 'where', field: 'isActive', operator: '==', value: true });
    }

    // conditions.push({ type: 'orderBy', field: 'name', direction: 'asc' });
    return await getAllDocuments(getCollectionPath(tenantId), conditions);
};

// Get factories by company ID
// This is tricky as we moved factories to be tenant-specific. 
// Assuming companyId refers to the global tenantId ?? Or some other entity?
// If factories are now children of Tenant, filtering by companyId (if inside the factory doc) is still valid.
// But we MUST know the tenantId to query.
export const getFactoriesByCompany = async (companyId, tenantId, activeOnly = false) => {
    if (!tenantId) throw new Error('Tenant ID is required');

    const conditions = [
        { type: 'where', field: 'companyId', operator: '==', value: companyId }
    ];

    if (activeOnly) {
        conditions.push({ type: 'where', field: 'isActive', operator: '==', value: true });
    }

    conditions.push({ type: 'orderBy', field: 'name', direction: 'asc' });

    return await getAllDocuments(getCollectionPath(tenantId), conditions);
};

// Update factory
export const updateFactory = async (factoryId, updates, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    const data = {
        ...updates,
        updatedAt: new Date()
    };
    return await updateDocument(getCollectionPath(tenantId), factoryId, data);
};

// Delete factory
export const deleteFactory = async (factoryId, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    return await deleteDocument(getCollectionPath(tenantId), factoryId);
};

// Deactivate factory
export const deactivateFactory = async (factoryId, tenantId) => {
    return await updateFactory(factoryId, { isActive: false }, tenantId);
};

// Activate factory
export const activateFactory = async (factoryId, tenantId) => {
    return await updateFactory(factoryId, { isActive: true }, tenantId);
};
